module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"enable_disable_shipping_zones":"Enable / Disable shipping zones for this form."},"id":{"enable_disable_shipping_zones":"Aktif / Nonaktifkan Zona pengiriman untuk form ini."}}')
  delete Component.options._Ctor
}
